<template>
  <hr class="semi" />
  <div
    style="
      background-color: black;
      border-top: 0.5px solid rgba(var(--white-color), 0.5);
      display: flex;
      justify-content: center;
      padding: var(--grid-gap-1) 0;
    "
  >
    <span style="font-size: var(--font-size-7)"
      >Coded with ❤︎ by
      <a target="_blank" rel="noopener noreferrer nofollow" href="https://github.com/adamsochorec"
        >Adam S.</a
      >
    </span>
  </div>
</template>
<style scoped></style>
